import { windowWidth } from '../../constants';

const regex = /^\d+-/;

export default () => {
  const contents = $('#contents');
  contents.find('p').addClass('article-p');
  contents.find('ul, ol').addClass('article-list');

  const blogHeadingTags = $('a[href^="#blog-heading-tag"]');

  if (contents.length > 0 && windowWidth > 1329) {
    const contentList = document.getElementById('content-list') as HTMLElement;

    const blogHeadingArr: Array<Element> = [...contents.find('h2, h3')];

    const blogHeadingIDsLen = blogHeadingArr.length;

    if (blogHeadingIDsLen > 0) {
      let currentHeading = document.getElementById(
        'main-heading-1'
      ) as HTMLElement;

      blogHeadingArr.map((currElement, index) => {
        // currElement.setAttribute('id', 'blog-heading-tag-' + (index + 1));
        currElement.setAttribute('id', `blog-heading-tag-${index + 1}`);

        if (currElement.textContent === String.fromCharCode(160)) {
          return false;
        }

        let modified: string | null = null;

        if (regex.test(currElement.textContent as string)) {
          // Check if the pattern matches the string
          modified = (currElement.textContent as string).replace(regex, ''); // Remove the matched part from the string
        }

        let li = document.createElement('li');

        if (currElement.tagName === 'H3') {
          const ul = document.createElement('ul');
          ul.classList.add('inner');

          const li_inner = document.createElement('li');
          li_inner.classList.add('sub');

          let link_inner = Object.assign(document.createElement('a'), {
            href: '#blog-heading-tag-' + (index + 1),
            innerText: currElement.textContent,
          });
          link_inner.innerHTML = link_inner.innerHTML
            .replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, '')
            .replace(/^&nbsp;/, '')
            .replace(/&nbsp;$/, '');
          li_inner.appendChild(link_inner);
          ul.appendChild(li_inner);
          currentHeading.appendChild(ul);
        } else {
          let link = Object.assign(document.createElement('a'), {
            href: '#blog-heading-tag-' + (index + 1),
            innerText: modified ? modified : currElement.textContent,
            className: '',
          });

          link.innerHTML = link.innerHTML
            .replace(/(<|&lt;)br\s*\/*(>|&gt;)/g, '')
            .replace(/^&nbsp;/, '')
            .replace(/&nbsp;$/, '');

          li.appendChild(link);
          li.classList.add('main-title');
          if (index === 0) {
            li.classList.add('intro');
          }
          li.setAttribute('id', 'main-heading-' + (index + 1));
          contentList.appendChild(li);
          currentHeading = document.getElementById(
            'main-heading-' + (index + 1)
          ) as HTMLElement;
        }
      });

      $('#content-table #content-list')
        .find('.main-title')
        .addClass('list-type-decimal');

      const sidebarNavs = $('#content-list li');

      $(window).on('scroll', function () {
        const scroll = $(this).scrollTop() as number;
        let selected: JQuery<HTMLElement>;

        for (let i = 0; i < blogHeadingIDsLen; i++) {
          if (scroll > (blogHeadingArr[i] as HTMLElement).offsetTop) {
            selected = sidebarNavs
              .find(`a[href="#${blogHeadingArr[i].id}"]`)
              .addClass('selected');
            selected.closest('.main-title').addClass('active-header');
            selected.parent().addClass('selected-li');

            sidebarNavs
              .find(`a:not([href="#${blogHeadingArr[i].id}"])`)
              .removeClass('selected')
              .parent()
              .removeClass('selected-li');
            selected
              .closest('.main-title')
              .siblings()
              .removeClass('active-header');
          }
        }
      });

      ///

      blogHeadingTags.on('click', function () {
        const { pathname, hostname } = location;

        if (
          pathname.replace(/^\//, '') ===
            (this as HTMLAnchorElement).pathname.replace(/^\//, '') ||
          hostname === (this as HTMLAnchorElement).hostname
        ) {
          const target = $((this as HTMLAnchorElement).hash);

          if (target.length) {
            $('html,body').animate(
              {
                scrollTop: (target.offset() as JQuery.Coordinates).top + 10,
              },
              300
            );
            return false;
          }
        }
      });
    } else {
      $('.blog-sidebar').css('display', 'none');
    }
  }
};
